import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Container, Grid, Typography, Button } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import img1 from "./../../assets/home/slide/slide-1-n.png";
// import img1 from "./../../assets/home/slide/slide-1.png";
import img2 from "./../../assets/home/slide/slide-2.png";
import img3 from "./../../assets/home/slide/slide-3.png";
import img4 from "./../../assets/home/slide/slide-4.png";
import img5 from "./../../assets/home/slide/slide-5.png";

const slides = [
  // {
  //   title: "Unlock your Potential with SAP S/4HANA",
  //   desc: "Transform your business into an intelligent enterprise with streamlined processes and data-driven decisions using SAP S/4HANA.",
  //   image: img1,
  //   path: "/services/sap-implementation-services",
  // },
  {
    title: "Transforming Businesses Through SAP, Technology & Innovation",
    desc: "We support organizations to accelerate growth with intelligent SAP solutions, digital transformation services, enterprise automation, and industry-focused consulting. Our mission is to simplify complex business operations through innovative technologies, strategic thinking, and measurable results.",
    image: img1,
    // image: img2,
    path: "/contact-us",
  },
  {
    title: "Take the First Step Towards Digital Transformation ",
    desc: "Digital transformation is no longer an option - it is the foundation for sustainable growth and operational excellence. We help organizations accelerate growth with intelligent SAP solutions, digital transformation services, enterprise automation, and industry-focused consulting. Our mission is to simplify complex business operations through innovative technologies, strategic thinking and measurable results.",
    image: img2,
    path: "/contact-us",
  },
  {
    title: "Trusted Partner for Digital Transformation",
    desc: "From SAP implementation and cloud transformation to automation, analytics, and managed services - we empower businesses to operate smarter, faster, and more efficiently.",
    image: img4,
    path: "/contact-us",
  },
  // {
  //   title: "SAP Support and Maintenance",
  //   desc: "Keep your SAP systems stable, secure, and optimized with professional ongoing support and maintenance.",
  //   image: img5,
  //   path: "/services/sap-support-and-maintenance",
  // },
];

const HeroBanner = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        position: "relative",
        background: "linear-gradient(135deg, #071525 0%, #082d63 100%)",
        color: "#fff",
        overflow: "hidden",

        "&::before": {
          content: '""',
          position: "absolute",
          width: "760px",
          height: "760px",
          left: "-330px",
          top: "50%",
          transform: "translateY(-50%)",
          borderRadius: "50%",
          background: `
      radial-gradient(circle, transparent 45%, rgba(0, 200, 83, 0.35) 46%, transparent 47%),
      repeating-radial-gradient(circle, transparent 0 85px, rgba(255,255,255,0.12) 86px 87px)
    `,
          animation: "orbitRotate 22s linear infinite",
          zIndex: 0,
        },

        "&::after": {
          content: '""',
          position: "absolute",
          inset: 0,
          backgroundImage: `
      radial-gradient(circle at 28% 35%, #18e0c2 0 5px, transparent 6px),
      radial-gradient(circle at 32% 42%, #18e0c2 0 5px, transparent 6px),
      radial-gradient(circle at 27% 50%, #18e0c2 0 5px, transparent 6px),
      radial-gradient(circle at 36% 52%, #18e0c2 0 5px, transparent 6px),
      radial-gradient(circle at 70% 28%, rgba(0,200,255,0.9) 0 4px, transparent 6px),
      radial-gradient(circle at 84% 64%, rgba(0,200,255,0.9) 0 4px, transparent 6px)
    `,
          animation: "floatDots 5s ease-in-out infinite alternate",
          zIndex: 0,
        },

        "& .tech-arrows": {
          position: "absolute",
          right: "12%",
          top: "28%",
          fontSize: "34px",
          letterSpacing: "8px",
          color: "rgba(24, 224, 194, 0.65)",
          animation: "moveArrows 3s ease-in-out infinite",
          zIndex: 0,
        },

        "& > *": {
          position: "relative",
          zIndex: 1,
        },

        "@keyframes orbitRotate": {
          from: {
            transform: "translateY(-50%) rotate(0deg)",
          },
          to: {
            transform: "translateY(-50%) rotate(360deg)",
          },
        },

        "@keyframes floatDots": {
          from: {
            transform: "translateY(0px)",
            opacity: 0.7,
          },
          to: {
            transform: "translateY(-18px)",
            opacity: 1,
          },
        },

        "@keyframes moveArrows": {
          "0%": {
            transform: "translateX(0)",
            opacity: 0.35,
          },
          "50%": {
            transform: "translateX(18px)",
            opacity: 0.9,
          },
          "100%": {
            transform: "translateX(0)",
            opacity: 0.35,
          },
        },

        "& .swiper-pagination-bullet": {
          backgroundColor: "rgba(255,255,255,0.7)",
          opacity: 1,
        },

        "& .swiper-pagination-bullet-active": {
          backgroundColor: "#00c853",
          width: 24,
          borderRadius: 10,
        },
      }}
    >
      <Swiper
        modules={[Autoplay, Pagination]}
        loop
        speed={800}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
      >
        {slides.map((slide, index) => {
          const isEvenSlide = index % 2 === 0;

          return (
            <SwiperSlide key={index}>
              <Box
                sx={{
                  minHeight: { xs: "auto", md: "82vh" },
                  display: "flex",
                  alignItems: "center",
                  py: { xs: 11, md: 4 },
                }}
              >
                <Container maxWidth="lg">
                  <Grid
                    container
                    alignItems="center"
                    rowSpacing={4}
                    columnSpacing={{ xs: 3, sm: 2, md: 5 }}
                  >
                    {/* Grid for text content */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{
                        order: {
                          xs: 1,
                          // md: isEvenSlide ? 1 : 2,
                        },
                      }}
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontSize: {
                            xs: "1.5rem",
                            sm: "2rem",
                            md: "2.5rem",
                          },
                          mb: 1,
                          fontWeight: 600,
                          lineHeight: 1.05,
                          letterSpacing: "-1.25px",
                          background:
                            "linear-gradient(90deg, #00E5FF 0%, #00C853 50%, #0B8CFF 100%)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                          backgroundSize: "200% auto",
                          animation: "gradientMove 6s linear infinite",
                          textShadow: "0 10px 30px rgba(0,229,255,0.15)",
                        }}
                      >
                        {slide.title}
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: { xs: "0.8rem", md: "1.15rem" },
                          lineHeight: 1.8,
                          color: "rgba(255,255,255,0.78)",
                          maxWidth: 650,
                          mb: 4,
                          textAlign: "justify",
                        }}
                      >
                        {slide.desc}
                      </Typography>

                      <Button
                        variant="contained"
                        onClick={() => navigate(slide.path)}
                        sx={{
                          px: 4,
                          py: 1.4,
                          borderRadius: "50px",
                          textTransform: "none",
                          fontWeight: 700,
                          background:
                            "linear-gradient(90deg, #00c853, #0b8cff)",
                          boxShadow: "0 12px 30px rgba(0, 140, 255, 0.25)",
                          "&:hover": {
                            background:
                              "linear-gradient(90deg, #0b8cff, #00c853)",
                          },
                        }}
                      >
                        Talk to Our Experts
                      </Button>
                    </Grid>

                    {/* Grid for image content */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{
                        order: {
                          xs: 2,
                          // md: isEvenSlide ? 2 : 1,
                        },
                        mt: { xs: 2, md: 0 },
                      }}
                    >
                      <Box
                        sx={{
                          position: "relative",
                          borderRadius: "22px",
                          overflow: "hidden",
                          boxShadow: "0 25px 70px rgba(0,0,0,0.45)",
                          "&::before": {
                            content: '""',
                            position: "absolute",
                            inset: 0,
                            background:
                              "linear-gradient(135deg, rgba(0,200,83,0.18), rgba(11,140,255,0.18))",
                            zIndex: 1,
                          },
                        }}
                      >
                        <Box
                          component="img"
                          src={slide.image}
                          alt={slide.title}
                          sx={{
                            width: "100%",
                            height: { xs: 260, sm: 360, md: 430 },
                            objectFit: "cover",
                            display: "block",
                          }}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Container>
              </Box>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </Box>
  );
};

export default HeroBanner;
